import { DetailNewsPage } from '@/components/News';
import {
  GetNewsByCategoriesIdDocument,
  GetNewsByIdDocument,
  GetNewsCategoriesBySlugDocument,
  NewsHomepageDocument,
  Order_By,
} from '@/generated/graphql';
import _format from '@/utils/format';
import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { addApolloState, initializeApollo } from '@/lib/apolloClient';
import { useRouter } from 'next/router';
import { getCurrentDateRoundedHour } from '@/utils';
import NewsCategoryPage from '@/components/News/NewsCategoryPage';
import { ITEMS_PER_PAGE } from '@/components/News/NewsCategoryBottomSection';

const DetailNews = () => {
  const router = useRouter();
  const { slug } = router.query;
  const id = _format.convertUrlToId(slug?.toString() || '');
  // if (Number.isNaN(Number(id))) return <DetailNewsCategoryPage />;
  if (Number.isNaN(Number(id))) return <NewsCategoryPage />;
  return <DetailNewsPage />;
};

export default DetailNews;

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async context => {
  const apolloClient = initializeApollo();
  const slug = context?.params?.slug;
  const id = _format.convertUrlToId(slug?.toString() || '');

  try {
    if (Number.isNaN(Number(id))) {
      const news_category = await apolloClient.query({
        query: GetNewsCategoriesBySlugDocument,
        variables: {
          where: {
            slug: {
              _like: slug,
            },
          },
        },
      });
      const top_news = await apolloClient.query({
        query: NewsHomepageDocument,
        variables: {
          limit: 5,
          where: {
            news_category: {
              id: { _eq: news_category?.data?.news_category?.[0]?.id },
            },
            isHot: { _eq: true },
            is_public: {
              _eq: true,
            },
          },
        },
      });

      const top_latest_news = await apolloClient.query({
        query: NewsHomepageDocument,
        variables: {
          limit: 5,
          where: {
            news_category: {
              id: { _eq: news_category?.data?.news_category?.[0]?.id },
            },
            update_at: {
              _lte: getCurrentDateRoundedHour(),
            },
            is_public: {
              _eq: true,
            },
          },
        },
      });

      if (Number(top_news?.data?.news?.length) < 5) {
        top_news?.data?.news.concat(top_latest_news?.data?.news as any);
      }

      await apolloClient.query({
        query: NewsHomepageDocument,
        variables: {
          limit: ITEMS_PER_PAGE,
          where: {
            news_category: {
              id: { _eq: news_category?.data?.news_category?.[0]?.id },
            },
            id: { _nin: top_news?.data?.news?.map((item: any) => item.id) },
            date: {
              _lte: getCurrentDateRoundedHour(),
            },
            is_public: {
              _eq: true,
            },
          },
        },
      });

      await apolloClient.query({
        query: NewsHomepageDocument,
        variables: {
          limit: 5,
          orderBy: {
            update_at: Order_By.Desc,
          },
          where: {
            news_category: {
              id: { _neq: news_category?.data?.news_category?.[0]?.id },
            },
            is_public: {
              _eq: true,
            },
          },
        },
      });

      const length = news_category?.data?.news_category?.length;

      if (!length || length === 0)
        return {
          redirect: {
            destination: '/404',
            permanent: false,
            revalidate: 30,
          },
        };
      return addApolloState(apolloClient, {
        props: {},
        revalidate: 30,
      });
    } else {
      const news = await apolloClient.query({
        query: GetNewsByIdDocument,
        variables: {
          newsByPkId: Number(id || ''),
        },
      });

      await apolloClient.query({
        query: NewsHomepageDocument,
        variables: {
          limit: 5,
          orderBy: [{ date: Order_By.DescNullsLast }],
          where: {
            id: {
              _neq: id,
            },
            news_category: {
              id: { _neq: news?.data?.news_by_pk?.category_id },
            },
            date: {
              _lte: getCurrentDateRoundedHour(),
            },
            is_public: {
              _eq: true,
            },
          },
        },
      });

      await apolloClient.query({
        query: GetNewsByCategoriesIdDocument,
        variables: {
          newsCategoryByPkId: news?.data?.news_by_pk?.category_id || 0,
          limit: 4,
          where: {
            id: {
              _neq: id,
            },
            date: {
              _lte: getCurrentDateRoundedHour(),
            },
            is_public: {
              _eq: true,
            },
          },
        },
      });

      if (!news?.data?.news_by_pk)
        return {
          redirect: {
            destination: '/404',
            permanent: false,
            revalidate: 30,
          },
        };
      return addApolloState(apolloClient, {
        props: {},
        revalidate: 30,
      });
    }
  } catch (e) {
    return {
      redirect: {
        destination: '/404',
        permanent: false,
        revalidate: 30,
      },
    };
  }
};
